import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
import UserProfile from './UserProfile';
import {
  updateEmail,
  updateNumber,
  updateAddressOne,
  updateAddressTwo,
  updateCountry,
  updateState,
  updateProduct,
  updateScanner,
  updateContactname,
  updateContactnumber,
  updateComment,
  updateDestination,
  updateTat,
  // doUserProfileUpdate,
  getUserProfileData,
  doUserProfileUpdate,
  resetProfile,
  updateOcclusion,
  updateDesignType,
  updatePonticDesign,
  updateContact,
  updateModelType,
  updateNotes,
  doDesignPreferencesUpdate,
  updateDsoftware,
} from '../../actions/userProfileAction';
import { doCheckAuthentication } from 'src/actions/aunthenticateAction';
// import { push } from 'react-router-redux';

export const mapStateToProps = (state: AppState) => {
  return {
    customertype: state.userProfileData.custtype,
    customername: state.userProfileData.custname,
    customernumber: state.userProfileData.custnumber,
    customeremail: state.userProfileData.custemail,
    customeraddressone: state.userProfileData.custaddressone,
    customeraddresstwo: state.userProfileData.custaddresstwo,
    customercountry: state.userProfileData.custcountry,
    customerstate: state.userProfileData.custstate,
    customerproduct: state.userProfileData.custproduct,
    customerscanner: state.userProfileData.custscanner,
    customercontactName: state.userProfileData.custcontactName,
    customercontactNumber: state.userProfileData.custcontactNumber,
    customercomment: state.userProfileData.custcomment,
    custdsoft: state.userProfileData.custdsoft,
    custdest: state.userProfileData.custdest,
    custtat: state.userProfileData.custtat,

    occlusion: state.userProfileData.occlusion,
    designType: state.userProfileData.designtype,
    ponticDesign: state.userProfileData.ponticdesign,
    contact: state.userProfileData.contact,
    modelType: state.userProfileData.modeltype,
    notes: state.userProfileData.notes,

    custname: state.userProfileData.userProfiledata.custname,
    emailid: state.userProfileData.userProfiledata.emailid,
    phoneno: state.userProfileData.userProfiledata.phoneno,
    address1: state.userProfileData.userProfiledata.address1,
    address2: state.userProfileData.userProfiledata.address2,
    country: state.userProfileData.userProfiledata.country,
    state: state.userProfileData.userProfiledata.state,
    products: state.userProfileData.userProfiledata.products,
    scanners: state.userProfileData.userProfiledata.scanners,
    contactname: state.userProfileData.userProfiledata.contactname,
    contactno: state.userProfileData.userProfiledata.contactno,
    comments: state.userProfileData.userProfiledata.comments,
    dsoft: state.userProfileData.userProfiledata.dsoft,
    destination: state.userProfileData.userProfiledata.destination,
    tat: state.userProfileData.userProfiledata.tat,

    occulsionArr: state.userProfileData.occulsionArr,
    designtypeArr: state.userProfileData.designtypeArr,
    contactArr: state.userProfileData.contactArr,
    ponticdesignArr: state.userProfileData.ponticdesignArr,
    modeltypeArr: state.userProfileData.modeltypeArr,

    designSoftwares: state.userProfileData.designSoftwares,
    orderDataManufacturer: state.fileUpload.orderDataManufacturer,
    orderDataTat: state.fileUpload.orderDataTat
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
  return {
    onSubmit: () => {
      // dispatch(fetchCurrentUser);
      dispatch(doUserProfileUpdate);
    },
    onSubmitDesign: () => {
      dispatch(doDesignPreferencesUpdate);
    },
    onReset: () => {
      dispatch(resetProfile);
    },
    updateEmail: (customeremail: string) => {
      dispatch(updateEmail(customeremail));
    },
    updateNumber: (customernumber: string) => {
      dispatch(updateNumber(customernumber));
    },
    updateAddressOne: (customeraddressone: string) => {
      dispatch(updateAddressOne(customeraddressone));
    },
    updateAddressTwo: (customeraddresstwo: string) => {
      dispatch(updateAddressTwo(customeraddresstwo));
    },
    updateCountry: (customercountry: string) => {
      dispatch(updateCountry(customercountry));
    },
    updateState: (customerstate: string) => {
      dispatch(updateState(customerstate));
    },
    updateProduct: (customerproduct: string) => {
      dispatch(updateProduct(customerproduct));
    },
    updateScanner: (customerscanner: string) => {
      dispatch(updateScanner(customerscanner));
    },
    updateContactname: (customercontactName: string) => {
      dispatch(updateContactname(customercontactName));
    },
    updateContactnumber: (customercontactNumber: string) => {
      dispatch(updateContactnumber(customercontactNumber));
    },
    updateComment: (customercomment: string) => {
      dispatch(updateComment(customercomment));
    },
    updateDsoftware: (dsoft: string) => {
      dispatch(updateDsoftware(dsoft));
    },
    updateDestination: (updatedestination: string) => {
      dispatch(updateDestination(updatedestination));
    },
    updateTat: (updatetat: string) => {
      dispatch(updateTat(updatetat));
    },
    updateOcclusion: (occlusion: string) => {
      dispatch(updateOcclusion(occlusion));
    },
    updateDesignType: (designtype: string) => {
      dispatch(updateDesignType(designtype));
    },
    updatePonticDesign: (Ponticdesign: string) => {
      dispatch(updatePonticDesign(Ponticdesign));
    },
    updateContact: (contact: string) => {
      dispatch(updateContact(contact));
    },
    updateModelType: (modeltype: string) => {
      dispatch(updateModelType(modeltype));
    },
    updateNotes: (notes: string) => {
      dispatch(updateNotes(notes));
    },
    // saveOcclusion: (event: string) => {
    //   dispatch(occlusionData);
    // },
    onComponentDidMount: () => {
      // dispatch(getUserProfileData);
    },
    onComponentWillMount: () => {
      dispatch(doCheckAuthentication);
      dispatch(getUserProfileData);
    }
  };
};

const UserProfileContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(UserProfile);

export default UserProfileContainer;



// WEBPACK FOOTER //
// ./src/components/userProfile/UserProfileContainer.tsx